import { DEFAULT_SORT_DIRECTION } from '../enums/sorting';
import { get, getLocalized } from './object';

const descendingComparator = (a: any, b: any, orderBy: string): number => {
  const getter = orderBy.indexOf('[]') === -1 ? get : getLocalized;
  let bVal = getter(b, orderBy, '');
  let aVal = getter(a, orderBy, '');

  if (typeof aVal === 'string') {
    aVal = aVal.toLowerCase();
  }
  if (typeof bVal === 'string') {
    bVal = bVal.toLowerCase();
  }

  if (bVal < aVal) {
    return -1;
  }
  if (bVal > aVal) {
    return 1;
  }
  return 0;
};

export const getComparator = (order: TOrder, orderBy: string) =>
  order === 'desc'
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);

export const sortData = (array: any[], comparator: (a: any, b: any) => number) =>
  array
    .map((el, index) => [el, index])
    .sort((a: any, b: any) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    })
    .map((el) => el[0]);

export const getNextOrder = (order?: TOrder): TOrder => {
  if (!order) return DEFAULT_SORT_DIRECTION;

  return order === 'asc' ? 'desc' : 'asc';
};

export type TOrder = 'asc' | 'desc';

export function orderWithFixedRows(arr, funcs, dirs) {
  return [...arr].sort((rowA, rowB) => {
    if (rowB.original.fixedRow) {
      return 1;
    }
    if (rowA.original.fixedRow) {
      return -1;
    }

    for (let i = 0; i < funcs.length; i += 1) {
      const sortFn = funcs[i];
      const desc = dirs[i] === false || dirs[i] === 'desc';
      const sortInt = sortFn(rowA, rowB);
      if (sortInt !== 0) {
        return desc ? -sortInt : sortInt;
      }
    }
    return dirs[0] ? rowA.index - rowB.index : rowB.index - rowA.index;
  });
}
